enum loginErrors {
  UserNotFound = 'User does not exist.',
  PasswordChange = 'You password needs to be changed before you can sign-in.',
  PasswordIncorrect = 'Incorrect username or password.',
}

export default loginErrors;
